import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";

import RadialProgress from "../utils/components/RadialProgress";

import { momentModule, roundToDecimals, parseAddress } from "../utils/Utils";
import { setAlert } from "../../actions/alertActions";
import ChargeAnimation from "../utils/components/ChargeAnimation";
import "../../styles/components/sessions/UserSessions.scss";
import "../../styles/utils/_loadingScreen.scss";
import no_sessions from "../../styles/images/no_sessions.svg";
import Select from "react-select";
const { moment, formatDate } = momentModule;


class UserSessions extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this._interval = null;
    this.cancel = null;

    this.state = {
      search: "",
      sessions: [],
      selectedSession: null,
      loading: false,
      listOfHwIds: [],
      selectedHwId: null,
      listOfLicensePlates: [],
      selectedLicensePlate: null,
      hoveredRow: null,
      modals: {
        chargeAnim: false,
      },
    };

    this.fetchSessions = this.fetchSessions.bind(this);
    this.customStyles = this.customStyles.bind(this);
    this.getSessionCellClass = this.getSessionCellClass.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchSessions();
    this._interval = setInterval(this.fetchSessions, 5 * 60 * 1000);
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
    if (this._interval !== null) clearInterval(this._interval);
  }

  fetchSessions() {
    this.safeSetState({
      loading: true,
    });
    axios
      .get("/api/private/connectionstation/myActiveSessions", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          const hwIdSet = new Set();
          const licensePlateSet = new Set();
          const listOfHwIds = [];
          const listOfLicensePlates = [];
          res.data.forEach((session) => {
            if (session.hwId && !hwIdSet.has(session.hwId)) {
              hwIdSet.add(session.hwId);
              listOfHwIds.push({ value: session.hwId, label: session.hwId });
            }
            const licensePlate = session?.evId?.licensePlate;
            if (licensePlate && !licensePlateSet.has(licensePlate)) {
              licensePlateSet.add(licensePlate);
              listOfLicensePlates.push({
                value: licensePlate,
                label: licensePlate,
              });
            }
          });
          this.safeSetState({
            listOfHwIds,
            listOfLicensePlates,
            sessions: res.data,
            loading: false,
          });
        }
      })
      .catch((err) => {
        this.props.setAlert(err?.response?.data?.message, "danger");
        this.safeSetState({
          loading: false,
        });
      });
  }

  stopSession(e, sessionId, hwId, plugId, evId, idTag, chargerType) {
    e.preventDefault();
    this.setModal("chargeAnim", true, () => {
      axios
        .get("/api/private/contracts", {
          cancelToken: new CancelToken((c) => (this.cancel = c)),
        })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.length > 0) {
              const userContracts = res.data.filter(
                (contract) => contract.contractType === "user",
              );
              if (userContracts.length > 0) {
                axios
                  .post(
                    "/api/private/connectionstation",
                    {
                      action: "stop",
                      hwId,
                      chargerType,
                      plugId,
                      sessionId,
                      evId,
                      chargerId: hwId,
                      idTag,
                    },
                    { cancelToken: new CancelToken((c) => (this.cancel = c)) },
                  )
                  .then((res) => {
                    if (res.status === 200) this.fetchSessions();
                  })
                  .catch((err) => {
                    this.setModal("chargeAnim", false);
                    this.props.setAlert(
                      I18n.t(err.response.data.message),
                      "danger",
                    );
                  });
              }
            }
          }
        })
        .catch((err) =>
          this.props.setAlert(I18n.t(err.response.data.message), "danger"),
        );
    });
  }

  setModal(modal, bool, callback) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState(
      {
        modals: newModals,
      },
      callback,
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  customStyles() {
    // from react-select docs (https://react-select.com/styles#provided-styles-and-state)
    // The recommended way to provide custom styles to react-select is to use the styles prop. styles takes an object with keys to represent the various inner components that react-select is made up of.

    const customStylesReactSelect = {
      control: (provided) => ({
        ...provided,
        borderRadius: "20px",
        minHeight: "2.7rem",
        height: "2.7rem",
        padding: "0px 5px",
      }),
      valueContainer: (provided) => ({
        ...provided,
        padding: "0px 1rem",
      }),
      input: (provided) => ({
        ...provided,
        margin: "0px",
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        height: "2.7rem",
      }),
    };
    return customStylesReactSelect;
  }

  getSessionCellClass(session, extra = "") {
    return (
      "col " +
      (this.state.hoveredRow === session._id
        ? "bg-bgdarkgrey"
        : "bg-bglightgrey") +
      (extra ? " " + extra : "")
    );
  }

  render() {
    let filteredSessions = this.state.sessions;

    const defaultChargerOption = { value: "", label: I18n.t("history_all") };
    const defaultOption = { value: "", label: I18n.t("history_all") };

    if (
      this.state.selectedLicensePlate &&
      this.state.selectedLicensePlate.value
    ) {
      filteredSessions = filteredSessions.filter(
        (data) =>
          data.evId &&
          data.evId.licensePlate === this.state.selectedLicensePlate.value,
      );
    }

    if (this.state.selectedHwId && this.state.selectedHwId.value) {
      filteredSessions = filteredSessions.filter(
        (data) => data.hwId && data.hwId === this.state.selectedHwId.value,
      );
    }

    // Custom styles for react-select with menuPortal zIndex
    const selectStylesWithPortal = {
      ...this.customStyles(),
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };

    return (
      <>
        <div id="userSessions" className="main-container">
          {this.state.sessions.length === 0 && !this.state.loading && (
            <div className="no-sessions">
              <img src={no_sessions} alt="" />
              <p className="title">
                <Translate value="sessions_noSessionsTitle" />
              </p>
              <p className="text">
                <Translate value="sessions_noSessionsText" />
              </p>
            </div>
          )}

          {this.state.sessions.length === 0 && this.state.loading && (
            <div className="loading-container flex-jcenter">
              <div className="loading-spinner">
                <div className="generic-loading">
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          )}
          {this.state.sessions.length !== 0 && !this.state.loading && (
            <div className="component-container space-between-container">
              <div className="search-select-row flex-row">
                <div className="select-label-container">
                  <p>
                    <Translate value="sessions_registration" />
                  </p>
                  <div className="smartSelect">
                    <Select
                      styles={selectStylesWithPortal}
                      value={this.state.selectedLicensePlate || defaultOption}
                      onChange={(e) => {
                        this.safeSetState({
                          selectedLicensePlate: e,
                        });
                      }}
                      defaultValue={defaultOption}
                      options={this.state.listOfLicensePlates}
                      isClearable={true}
                      menuPortalTarget={
                        typeof window !== "undefined" ? document.body : null
                      }
                      menuPosition="fixed"
                    />
                  </div>
                </div>

                <div className="select-label-container">
                  <p>
                    <Translate value="sessions_chargerId" />
                  </p>

                  <div className="smartSelect">
                    <Select
                      styles={selectStylesWithPortal}
                      value={this.state.selectedHwId || defaultChargerOption}
                      onChange={(e) => {
                        this.safeSetState({
                          selectedHwId: e,
                        });
                      }}
                      defaultValue={defaultChargerOption}
                      options={this.state.listOfHwIds}
                      isClearable={true}
                      menuPortalTarget={
                        typeof window !== "undefined" ? document.body : null
                      }
                      menuPosition="fixed"
                    />
                  </div>
                </div>
              </div>

              <div className="sticky-table-sizing">
                <table
                  className="table-collapse"
                  aria-label={I18n.t("label_sessions")}
                >
                  <thead>
                    <tr>
                      <th className="bg-evio-secondary-radius-left">
                        <Translate value="sessions_datetime" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_vehicle" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_registration" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_chargerId" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_connectorId" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_location" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_duration" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_energySupplied" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_instantPower" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_spent" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_battery" />
                      </th>
                      <th className="bg-evio-secondary-radius-right">
                        <Translate value="chargers_actions" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredSessions.map((session, index) => {
                      const ev = session.evId;
                      const m = moment
                        .duration(session.timeCharged, "seconds")
                        .format({ template: "hh:mm", trim: false });
                      return (
                        <tr
                          className="bg-bglightgrey tr-border"
                          key={
                            session._id ||
                            `fallback-${session?.chargerId}-${index}`
                          }
                          onMouseEnter={() => {
                            this.setState({
                              hoveredRow:
                                session._id ||
                                `fallback-${session?.chargerId}-${index}`,
                            });
                          }}
                          onMouseLeave={() => {
                            this.setState({ hoveredRow: null });
                          }}
                        >
                          <td className={this.getSessionCellClass(session)}>
                            {session.startDate ? (
                              formatDate(session.startDate, "monthtime")
                            ) : (
                              <p className="blank">―</p>
                            )}
                          </td>
                          <td className={this.getSessionCellClass(session)}>
                            {ev && (ev.brand || ev.model) ? (
                              `${ev.brand} ${ev.model}`
                            ) : (
                              <p className="blank">―</p>
                            )}
                          </td>
                          <td className={this.getSessionCellClass(session)}>
                            {ev && ev.licensePlate ? (
                              ev.licensePlate
                            ) : (
                              <p className="blank">―</p>
                            )}
                          </td>
                          <td className={this.getSessionCellClass(session)}>
                            {session.hwId ? (
                              session.hwId
                            ) : (
                              <p className="blank">―</p>
                            )}
                          </td>
                          <td className={this.getSessionCellClass(session)}>
                            {session.plugId ? (
                              session.plugId
                            ) : (
                              <p className="blank">―</p>
                            )}
                          </td>
                          <td className={this.getSessionCellClass(session)}>
                            {session ? (
                              parseAddress(session.address)
                            ) : (
                              <p className="blank">―</p>
                            )}
                          </td>
                          <td className={this.getSessionCellClass(session)}>
                            {m}
                          </td>
                          <td className={this.getSessionCellClass(session)}>
                            {session.totalPower &&
                            !Number.isNaN(session.totalPower) ? (
                              session.totalPower > 1000 ? (
                                roundToDecimals(
                                  session.totalPower / 1000,
                                  2,
                                ) === -1 ? (
                                  <p className="blank">―</p>
                                ) : (
                                  `${roundToDecimals(
                                    session.totalPower / 1000,
                                    2,
                                  )} kWh`
                                )
                              ) : roundToDecimals(session.totalPower, 2) ===
                                -1 ? (
                                <p className="blank">―</p>
                              ) : (
                                `${roundToDecimals(session.totalPower, 2)} Wh`
                              )
                            ) : (
                              <p className="blank">―</p>
                            )}
                          </td>
                          <td className={this.getSessionCellClass(session)}>
                            {session.readingPoints.length !== 0 ? (
                              session.readingPoints[
                                session.readingPoints.length - 1
                              ].instantPower > 1000 ? (
                                roundToDecimals(
                                  session.readingPoints[
                                    session.readingPoints.length - 1
                                  ].instantPower / 1000,
                                  2,
                                ) === -1 ? (
                                  <p className="blank">―</p>
                                ) : (
                                  `${roundToDecimals(
                                    session.readingPoints[
                                      session.readingPoints.length - 1
                                    ].instantPower / 1000,
                                    2,
                                  )} kW`
                                )
                              ) : session.readingPoints[
                                  session.readingPoints.length - 1
                                ].instantPower >= 0 ? (
                                roundToDecimals(
                                  session.readingPoints[
                                    session.readingPoints.length - 1
                                  ].instantPower,
                                  2,
                                ) === -1 ? (
                                  <p className="blank">―</p>
                                ) : (
                                  `${roundToDecimals(
                                    session.readingPoints[
                                      session.readingPoints.length - 1
                                    ].instantPower,
                                    2,
                                  )} W`
                                )
                              ) : (
                                <p className="blank">―</p>
                              )
                            ) : (
                              <p className="blank">―</p>
                            )}
                          </td>
                          <td className={this.getSessionCellClass(session)}>
                            {session.estimatedPrice &&
                            !Number.isNaN(session.estimatedPrice) ? (
                              roundToDecimals(session.estimatedPrice, 2)
                            ) : (
                              <p className="blank">―</p>
                            )}
                          </td>
                          <td className={this.getSessionCellClass(session)}>
                            <div className="battery-info-container">
                              {session.batteryCharged &&
                              !Number.isNaN(session.batteryCharged) &&
                              session.batteryCharged !== -1 ? (
                                `${Math.round(session.batteryCharged)}%`
                              ) : (
                                <p className="blank battery-blank">―</p>
                              )}
                              <RadialProgress
                                size={42}
                                value={session.batteryCharged / 100}
                              />
                            </div>
                          </td>
                          <td
                            className={
                              this.getSessionCellClass(session) + " addShadows"
                            }
                          >
                            <button
                              type="button"
                              className="stop-btn"
                              onClick={(e) =>
                                this.safeSetState(
                                  { selectedSession: session },
                                  () =>
                                    this.stopSession(
                                      e,
                                      session.sessionId,
                                      session.hwId,
                                      session.plugId,
                                      (session.evId && session.evId._id) ||
                                        "-1",
                                      session.idTag,
                                      session.chargerType,
                                    ),
                                )
                              }
                            >
                              <Translate value="sessions_stop" />
                            </button>
                          </td>
                        </tr>
                      );
                      
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <div className="refresh-info">
            * <Translate value="sessions_refreshInfo" />
          </div>
        </div>

        <ChargeAnimation
          show={this.state.modals.chargeAnim}
          onHide={() => this.setModal("chargeAnim", false)}
          chargerType={
            this.state.selectedSession !== null &&
            this.state.selectedSession.chargerType
          }
          sessionId={
            this.state.selectedSession !== null &&
            this.state.selectedSession.sessionId
          }
          direction={-1}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  id: state.account.accountData.id,
});

export default connect(mapStateToProps, { setAlert })(UserSessions);
